import { createContext, useContext } from 'react';
import { useVirtualScroll } from '../../hooks/useVirtualScroll';
import type { VirtualScrollComboboxContextState as Context } from '../../types';
import useEventsHandler from './useEventsHandler';

export const VirtualScrollComboboxContext = createContext<Context>(
  {} as Context
);

export const useVirtualScrollCombobox = () => {
  const context = useContext(VirtualScrollComboboxContext);

  const virtualScrollContext = useVirtualScroll();
  const { handleKeyEvent } = useEventsHandler(virtualScrollContext);

  if (!context) {
    throw new Error(
      'useVirtualScrollCombobox must be used within a VirtualScrollComboboxProvider'
    );
  }

  return { ...virtualScrollContext, ...context, handleKeyEvent };
};
